'use strict'

module.exports = {
  isClean: Symbol('isClean')
}
